import { Col, Row } from "reactstrap";
import imagenAlbox from "../../../assets/avantSolar/Promociones/Huertas/promociones-4-albox.jpg";
import imagenTabernas from "../../../assets/avantSolar/Promociones/Huertas/promociones-4-tabernas.jpg";
import imagenIniesta from "../../../assets/avantSolar/Promociones/Huertas/promociones-4-iniesta.jpg";
import imagenMesia from "../../../assets/avantSolar/Promociones/Huertas/promociones-4-vmesia.jpg";
import imagenJara from "../../../assets/avantSolar/Promociones/Huertas/promociones-4-vlajara.jpg";

const HuertosSolares = ({ setImagen }) => {
  return (
    <>
      <div>
        <p className="p-0 m-0 h4 text-center text-sm-left font-weight-bold">
          HUERTAS SOLARES
        </p>
        <hr></hr>

        <div className="pl-5 pt-3 pr-5">
          <p>Más de 10MW conectados a red en 2008:</p>
          <Row className="mt-5">
            <Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenTabernas);
                  }}
                >
                  <p className="textoInstalaciones">TABERNAS - 800KW</p>
                  <ul>
                    <li>
                      Seguidores de doble eje. Conectada a red en Septiembre de
                      2007
                    </li>
                  </ul>
                </div>
              </Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenIniesta);
                  }}
                >
                  <p className="textoInstalaciones">INIESTA - 5MW</p>
                  <ul>
                    <li>
                      Seguidores de un eje AvantTracker. Primera fase de 2MW
                      conectada a red en Febrero 2008, segunda y tercera fase
                      conectadas en Abril y Julio de 2008 respectivamente.
                    </li>
                  </ul>
                </div>
              </Col>
            </Col>
            <Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenMesia);
                  }}
                >
                  <p className="textoInstalaciones">
                    VILLANUEVA DE MESIA - 1.8MW
                  </p>
                  <ul>
                    <li>
                      Seguidores de un eje AvantTracker. Conectada a red en Mayo
                      de 2008.
                    </li>
                  </ul>
                </div>
              </Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenJara);
                  }}
                >
                  <p className="textoInstalaciones">
                    VILLANUEVA DE LA JARA - 2MW
                  </p>
                  <ul>
                    <li>
                      Seguidores de un eje AvantTracker. Conectada a red en
                      Junio de 2008.
                    </li>
                  </ul>
                </div>
              </Col>
              <Col>
                <div
                  className="pointer"
                  onClick={() => {
                    setImagen(imagenAlbox);
                  }}
                >
                  <p className="textoInstalaciones">ALBOX - 1MW</p>
                  <ul>
                    <li>
                      Seguidores de un eje AvantTracker 15. Conectada a red en
                      Agosto de 2008.
                    </li>
                  </ul>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default HuertosSolares;
